import { render, staticRenderFns } from "./BranchTransferCreate.vue?vue&type=template&id=1dc47f6a&"
import script from "./BranchTransferCreate.vue?vue&type=script&lang=js&"
export * from "./BranchTransferCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports